import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'
import NotFound from '../NotFound/NotFound'
import { setPageTitle } from '../redux/slice/pageTitleSlice'
import CommissionReport from './CommissionReport'
import OrderReport from './OrderReport'
import ProductReport from './ProductReport'

const ManageReport = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setPageTitle('Manage Report'))
  }, [])
  const { pageAccess } = useSelector((state) => state.user)

  const [activeToggle, setActiveToggle] = useState('order')

  return checkPageAccess(pageAccess, [allPages?.report], allCrudNames?.read) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.report,
              allCrudNames?.read
            ) && (
              <Link
                onClick={() => setActiveToggle('order')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'order' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Order
                  <hr />
                </span>
              </Link>
            )}

            {checkPageAccess(
              pageAccess,
              allPages?.report,
              allCrudNames?.read
            ) && (
              <Link
                onClick={() => setActiveToggle('product')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'product' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Product
                  <hr />
                </span>
              </Link>
            )}

            {checkPageAccess(
              pageAccess,
              allPages?.report,
              allCrudNames?.read
            ) && (
              <Link
                onClick={() => setActiveToggle('commission')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'commission' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Commission
                  <hr />
                </span>
              </Link>
            )}
          </div>

          <div className='tab-content p-3'>
            {checkPageAccess(
              pageAccess,
              allPages?.report,
              allCrudNames?.read
            ) && (
              <div
                className={`tab-pane fade ${
                  activeToggle === 'order' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'order' && <OrderReport />}
              </div>
            )}

            {checkPageAccess(
              pageAccess,
              allPages?.report,
              allCrudNames?.read
            ) && (
              <div
                className={`tab-pane fade ${
                  activeToggle === 'product' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'product' && <ProductReport />}
              </div>
            )}

            {checkPageAccess(
              pageAccess,
              allPages?.report,
              allCrudNames?.read
            ) && (
              <div
                className={`tab-pane fade ${
                  activeToggle === 'commission' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'commission' && <CommissionReport />}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default ManageReport
